import PDFAllPageViewer from './PDFAllPageViewer';

export default PDFAllPageViewer;
